import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { color } from '../../../styles/theme';

const DotWrapper = styled.div`
  display: inline-block;
  margin: 0 20px 0 10px;
  > svg {
    display: block;
  }
`;

const Dot = ({ dotSize = '17' }) => (
  <DotWrapper aria-hidden="true">
    <svg
      width="9"
      height={dotSize}
      viewBox="0 0 9 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="4.5"
        cy={dotSize - 3}
        r={2.5}
        fill={`${color.textPrimary}`}
        fillRule="evenodd"
      />
    </svg>
  </DotWrapper>
);

Dot.propTypes = {
  dotSize: PropTypes.number
};

export default Dot;
